import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { AvatarComponent } from 'ngx-avatars';

@Component({
    selector: 'epx-avatar-component',
    template: `
        <section class="avatar-wrapper">
            <ngx-avatars [bgColor]="bgColor()" [fgColor]="fgColor()" [size]="size()" [name]="name()"></ngx-avatars>
        </section>
    `,
    imports: [CommonModule, AvatarModule, AvatarComponent]
})
export class EpxAvatarComponent {
    name = input<string>('');
    size = input<number>(36);
    bgColor = input<string>('#323232');
    fgColor = input<string>('#ffffff');
}
